export default __webpack_public_path__ + "static/char-s-01-kr-8545f37a6d495f7225e89ff25097c036.webp";